
















import { Component, Vue } from "vue-property-decorator";
import PortfolioItem from "./PortfolioItem.vue";
import { Getter, State } from "vuex-class";
import { Balance, Statistics } from "@foxone/api/src/models/hfox";

@Component({
  components: {
    PortfolioItem
  }
})
class HFoxPortfolio extends Vue {
  @Getter("auth/isLogged") isLogged;

  @State(state => state.hfox.balance) hfoxAssets!: Balance;

  @State(state => state.hfox.statistics) hfoxStatistics!: Statistics;

  @State(state => state.wallet.mixin.hidden) hidden;

  get meta() {
    const fiat = this.$common.utils.currency.fiat;
    const getColor = this.$common.utils.helper.getColor;
    const isDark = this.$vuetify.theme.dark;

    const hideText = "*****";
    const isLogged = this.isLogged;
    const hfoxAssets = this.hfoxAssets || {};
    const hfoxBalanceText = this.hidden
      ? hideText
      : `≈${fiat(this, {
          value: hfoxAssets.balance,
          from: "USDT"
        })}`;
    const hfoxYesterdayEarn = Number(
      this.hfoxStatistics?.yesterday_earn ?? "0"
    );
    const symbol = hfoxYesterdayEarn >= 0 ? "+" : "-";
    const hfoxLastRevenue = this.hidden
      ? hideText
      : symbol +
        fiat(this, {
          value: Math.abs(hfoxYesterdayEarn),
          from: "USDT"
        });
    const hfoxLastRevenueColor = getColor(this.$store, hfoxYesterdayEarn);

    return {
      hfoxLastRevenueColor,
      hfoxLastRevenue,
      item: {
        title: this.$t("hfox"),
        background: require("@/assets/images/background_3.png"),
        icon: require("@/assets/images/logo_hfox.png"),
        iconSize: 26,
        color: isDark ? "#1e2d33" : "#EAFAFF",
        content: !isLogged ? this.$t("hfox.start") : hfoxBalanceText
      }
    };
  }
}
export default HFoxPortfolio;
